"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var IconChevron = function IconChevron(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? '' : _ref$variant;
  if (size === 'medium' & variant === 'link') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
      className: "IconChevron icon ".concat(className || ''),
      width: "10",
      height: "19",
      viewBox: "0 0 10 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1.25 2L8.75 9.5L1.25 17",
        stroke: "#0A5EC0",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    });
  } else if (size === 'small' & variant === 'link') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
      className: "IconChevron icon ".concat(className || ''),
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M5 2.5L11 8.5L5 14.5",
        stroke: "#0A5EC0",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      className: "IconChevron icon ".concat(className || ''),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      role: "img",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
          id: "b",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            width: "24",
            height: "24"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "a",
        clipPath: "url(#b)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M-690.438-218.723l-1.7-1.7a1,1,0,0,1,0-1.414l8.594-8.594-8.594-8.594a1,1,0,0,1,0-1.414l1.7-1.7a1,1,0,0,1,1.414,0l9.068,9.069a1,1,0,0,1,.272.193l1.7,1.7a1,1,0,0,1,.292.746,1,1,0,0,1-.292.746l-1.7,1.7a1,1,0,0,1-.272.193l-9.068,9.068a1,1,0,0,1-.707.293A1,1,0,0,1-690.438-218.723Z",
          transform: "translate(697.429 242.43)"
        })
      })]
    });
  }
};
var _default = IconChevron;
exports["default"] = _default;